import React from 'react';
import { Card, Tag, Typography, Space } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

// Contrato de GET /api/professor/aulas-dadas (Fase 14B): id, id_turma,
// nome_turm, data_aula, hora_inicio, hora_fim, duracao_horas, status,
// observacoes. NÃO inclui unidade/modalidade -- este endpoint do Portal
// nunca retornou esses campos (confirmado antes do redesign da Fase
// 14E-visual); o card usa exclusivamente os dados reais disponíveis, sem
// inventar informação.

const STATUS_INFO = {
  PENDENTE: { color: 'gold', text: 'Pendente' },
  VALIDADA: { color: 'green', text: 'Validada' },
  REJEITADA: { color: 'red', text: 'Rejeitada' },
};

const formatarHorario = (horaInicio, horaFim) =>
  horaInicio && horaFim
    ? `${dayjs(horaInicio, 'HH:mm:ss').format('HH:mm')} - ${dayjs(horaFim, 'HH:mm:ss').format('HH:mm')}`
    : '-';

// Humaniza duracao_horas (ex.: 1.5 -> "1h 30min") -- apenas formatação de
// apresentação do valor já calculado pelo backend, nunca recalcula nada.
const formatarDuracao = (horas) => {
  if (horas == null) return '-';
  const totalMinutos = Math.round(horas * 60);
  const h = Math.floor(totalMinutos / 60);
  const m = totalMinutos % 60;
  if (h === 0) return `${m}min`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}min`;
};

const AulaDadaProfessorCard = ({ aula }) => {
  const statusInfo = STATUS_INFO[aula.status] || { color: 'default', text: aula.status };
  const data = dayjs(aula.data_aula);

  return (
    <Card className="portal-professor__card" data-testid="aula-dada-card">
      <div className="portal-professor__aula-card">
        <div className="portal-professor__aula-data-bloco">
          <span className="portal-professor__aula-data-dia">{data.format('DD')}</span>
          <span className="portal-professor__aula-data-mes">{data.format('MMM').toUpperCase()}</span>
          <span className="portal-professor__aula-data-dow">{data.format('ddd')}</span>
        </div>

        <div className="portal-professor__aula-conteudo">
          <div className="portal-professor__aula-titulo-linha">
            <Text strong style={{ fontSize: 16, lineHeight: 1.3, wordBreak: 'break-word' }}>
              {aula.nome_turm}
            </Text>
            <Tag color={statusInfo.color}>{statusInfo.text}</Tag>
          </div>

          <Space size={16} wrap className="portal-professor__aula-info-linha">
            <Text type="secondary" style={{ fontSize: 13 }}>
              {formatarHorario(aula.hora_inicio, aula.hora_fim)}
            </Text>
            <Text type="secondary" style={{ fontSize: 13 }}>
              {formatarDuracao(aula.duracao_horas)}
            </Text>
          </Space>

          {aula.observacoes && (
            <Text type="secondary" className="portal-professor__aula-obs">
              {aula.observacoes}
            </Text>
          )}
        </div>
      </div>
    </Card>
  );
};

export default AulaDadaProfessorCard;
